import { render } from "./RegisterInfo.vue?vue&type=template&id=653252fa&scoped=true"
import script from "./RegisterInfo.vue?vue&type=script&lang=js"
export * from "./RegisterInfo.vue?vue&type=script&lang=js"

import "./RegisterInfo.vue?vue&type=style&index=0&id=653252fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653252fa"]])

export default __exports__